import { useState } from "react";

export function useSubmitLock() {
  const [isLoading, setIsLoading] = useState(false);

  const guard = async (submit: () => Promise<void> | void) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await submit();
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  return { isLoading, guard };
}
